.icon {
	display: inline-block;
	vertical-align: -0.125em;
	flex-shrink: 0;
}
